/**
 * Opens the BiteSpeed marketing popup from any theme link whose href starts
 * with #bitespeed-popup, so signups stay in BiteSpeed's own flow (and get its
 * discount code) rather than the theme reimplementing their opt-in API.
 *
 * BiteSpeed exposes window.openPopupBitespeed(a, n, popupId) — only the third
 * argument is used — and registers each popup in window.bitespeed_popups under
 * the key `<popupId>:bitespeed_popup`.
 *
 * Target a specific popup with #bitespeed-popup-<id>; plain #bitespeed-popup
 * opens whichever popup is registered first.
 */
(function () {
  var TRIGGER = 'a[href*="#bitespeed-popup"], [data-bitespeed-popup]';
  var READY_TIMEOUT = 10000;
  var POLL_INTERVAL = 300;

  function registeredIds() {
    var registry = window.bitespeed_popups;
    if (!registry || typeof registry !== 'object') return [];

    return Object.keys(registry).map(function (key) {
      return key.split(':')[0];
    });
  }

  function requestedId(trigger) {
    var href = trigger ? trigger.getAttribute('href') || '' : '';
    var match = href.match(/#bitespeed-popup-(.+)$/);
    return match ? match[1] : trigger && trigger.getAttribute('data-bitespeed-popup');
  }

  function resolveId(trigger) {
    var ids = registeredIds();
    if (ids.length === 0) return null;

    // Fall back to any available popup if the requested one has gone away —
    // BiteSpeed mints a new id whenever a campaign is recreated.
    var wanted = requestedId(trigger);
    return wanted && ids.indexOf(wanted) !== -1 ? wanted : ids[0];
  }

  function isReady() {
    return typeof window.openPopupBitespeed === 'function' && registeredIds().length > 0;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(TRIGGER);
    if (!trigger) return;

    event.preventDefault();

    var id = resolveId(trigger);
    if (!id) return;

    try {
      window.openPopupBitespeed(null, null, id);
    } catch (error) {
      /* Leaving the button in place is better than a half-broken state. */
    }
  });

  /**
   * BiteSpeed loads async, so wait before deciding it isn't coming. A trigger
   * that can never open anything is hidden rather than left as a dead button.
   */
  function watch() {
    var triggers = document.querySelectorAll(TRIGGER);
    if (triggers.length === 0) return;

    var waited = 0;
    var timer = setInterval(function () {
      waited += POLL_INTERVAL;

      if (isReady()) {
        clearInterval(timer);
        return;
      }

      if (waited >= READY_TIMEOUT) {
        clearInterval(timer);
        Array.prototype.forEach.call(triggers, function (trigger) {
          trigger.hidden = true;
        });
      }
    }, POLL_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
